import script from "./AddEditBasketIndexView.vue?vue&type=script&setup=true&lang=js"
export * from "./AddEditBasketIndexView.vue?vue&type=script&setup=true&lang=js"

import "./AddEditBasketIndexView.vue?vue&type=style&index=0&id=f2a85f62&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2a85f62"]])

export default __exports__